import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";
import { projectsDataStore } from "Stores/ProjectsStore";
import { fileDownloadStore, LedIndicatorsOptions } from "./FileDownloadStore";

interface LedIndicatorsProps extends WithTranslation {
  options: { [key in LedIndicatorsOptions]?: boolean };
}

export const LedIndicators = withTranslation(I18N_NS.PROJECT)(({ options, t }: LedIndicatorsProps) => {
  const config: { [key in LedIndicatorsOptions]?: string } = {
    pdfConversion: "led-light",
    qrcode: "led-light",
  };
  if (fileDownloadStore.furtherOptionsDisabled) {
    return null;
  }
  for (const key in options) {
    if (Object.prototype.hasOwnProperty.call(options, key) && options[key]) {
      config[key] = `${config[key]} led-on`;
    }
  }

  let qrToolTip: string = null;
  if (projectsDataStore.isQRForce()) {
    if (projectsDataStore.isQrMDFilter()) {
      qrToolTip = "This option is always enabled due to the project requirements for certain files.";
    } else {
      qrToolTip = "This option is always enabled due to the project requirements.";
    }
  }

  return (
    <div>
      <div className="led-indicator">
        <div className="led-title">{t("PDF Conversion")}</div>
        <div className={config.pdfConversion} />
      </div>
      <div className="led-indicator">
        <div className="led-title">{t("Watermarks")}</div>
        <div className={"led-light led-on"} />
      </div>
      <div className="led-indicator">
        <div className="led-title">
          {qrToolTip !== null ? (
            <Tooltip title={t(qrToolTip)}>
              <FontAwesomeIcon icon={["far", "info-circle"]} color="blue" style={{ marginRight: "5px" }} />
            </Tooltip>
          ) : (
            ""
          )}
          {t("QR Code")}
        </div>
        <div className={config.qrcode} />
      </div>
    </div>
  );
});
